<!-- <template>
    <div class="mainWrapper">
        <button @click="downloadPDF" class="pdfGenerateButton">
            <img :src='downloadPdf' class="pdfDownloadIcon" alt="download icon" />
            <div class="d-none">Download PDF</div>
        </button>
        <div ref="content" id="content" class="pdp-contentBoxes">
            <div class="page-heading m_lr-auto">
                <img :src='textHead' alt="heading image" />
            </div>
            <div class="pdf-contentBox">
                <div class="text-center">
                    <img :src='totalTimeCalculation' class="max-w-80" alt="Total time calcution" />
                    <br />
                    <span class="text-center">
                        <img :src='line' alt="bottom line" />
                    </span>
                </div>
                <div class="text-center mt-15">
                    <img :src='rulesHeading' class="max-w-80" alt="rules heading" />
                    <h1 class="p-relative text-italic white-text heading-1 d-none">
                        <div>What Rules For</div>
                        <div>Being Eligible?</div>
                    </h1>
                </div>
                <div class="white-text rulelistBox">
                    <ul>
                        <li v-for="(rule, index) in rules" :key="index">
                            <div class="list-bulletIcon">
                                <img :src='listBulletArrow' alt="" />
                            </div>
                            <div class="list-contet">
                                {{ rule }}
                                <div class="text-center">
                                    <img :src='listBulletLine' alt="" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="text-center mt-15">
                    <img :src='guidelinesHeading' class="max-w-80" alt="Guildlines heading" />
                    <h2 class="p-relative text-italic white-text heading-1 d-none">
                        <div>Guidelines For</div>
                        <div>Livestreaming</div>
                    </h2>
                </div>
                <div class="white-text rulelistBox">
                    <ul>
                        <li v-for="(guidelinesForLiveStreaming, index) in guidelinesForLiveStreaming" :key="index">
                            <div class="list-bulletIcon">
                                <img :src='listBulletArrow' alt="" />
                            </div>
                            <div class="list-contet">
                                {{ guidelinesForLiveStreaming }}
                                <div class="text-center">
                                    <img :src='listBulletLine' alt="" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="pdf-bottomBox">
                    <div class="pdf-bottom-leftBox">
                        <div class="p-relative">
                            <img :src='bottomAmountBg' alt="" />
                            <div class="pdf-bottomReward-box">
                                <div class="flexBox itemCenter justify-center white-text">
                                    <div class="pdf-bottomRewardVal">150000</div>
                                    <div class="p-relative pdf-bottom-beansIcon">
                                        <img :src='beansWithStar' alt="Beans Icon" />
                                    </div>
                                </div>
                            </div>
                            <div class="rewardText-bottom">
                                <img :src='rewardText' alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="p-relative pdf-bottom-rightBox">
                        <img :src='beansLootBox' alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import '../../assets/css/freetarget.css'
import downloadPdf from '../../assets/images/feetargerImages/download-pdf.png'
import textHead from '../../assets/images/feetargerImages/textHead.png'
import totalTimeCalculation from '../../assets/images/feetargerImages/totalTimeCalculation.png'
import moreTimeHave from '../../assets/images/feetargerImages/moreTimeHave.png'
import rulesHeading from '../../assets/images/feetargerImages/rulesHeading.png'
import guidelinesHeading from '../../assets/images/feetargerImages/guidelinesHeading.png'
import listBulletLine from '../../assets/images/feetargerImages/listBulletLine.png'
import listBulletArrow from '../../assets/images/feetargerImages/listBulletArrow.png'
import line from '../../assets/images/feetargerImages/line.png'
import bottomAmountBg from '../../assets/images/feetargerImages/bottomAmountBg.png'
import beansWithStar from '../../assets/images/feetargerImages/beansWithStar.png'
import beansLootBox from '../../assets/images/feetargerImages/beansLootBox.png'
import rewardText from '../../assets/images/feetargerImages/as-a-reward.png'


export default {
    name: 'FreetargetUpdate',
    data() {
        return {
            downloadPdf:downloadPdf,
            textHead: textHead,
            totalTimeCalculation:totalTimeCalculation,
            moreTimeHave: moreTimeHave,
            rulesHeading: rulesHeading,
            guidelinesHeading: guidelinesHeading,
            listBulletLine: listBulletLine,
            listBulletArrow: listBulletArrow,
            line: line,
            bottomAmountBg: bottomAmountBg,
            beansWithStar: beansWithStar,
            beansLootBox: beansLootBox,
            rewardText:rewardText,
            rules: [
                "Timing extended for streaming 24/7.",
                "One should do live streaming and call for minimum of 4 hours a day (In total).",
                "For rewards, one should collect a minimum of 4 Stars in a week (*1 Star = Minimum 4 Hours Live Streaming/day).",
                "In this scheme one will get 150,000 coins as a reward on each Monday.",
                "Host/ Live Streamer has to make minimum of 50,000 beans/weeks for rewards."
            ],
            guidelinesForLiveStreaming: [
                "Live Streamer background should be neat and clean. For better background one can use good background color.",
                "Live Streamer should use Bluetooth for voice clarity and Ring Light for Excellent Beatification Effects",
                "Live Streamer should wear smart casuals."
            ]
        }
    },
    methods: {
        async downloadPDF() {
            const content = this.$refs.content;

            html2canvas(content, {
                scale: 3,
                useCORS: true,
                backgroundColor: null,
                logging: false,
                windowWidth: document.body.scrollWidth,
            }).then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
                const imgWidth = 210;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                const pdf = new jsPDF("p", "mm", [imgWidth, imgHeight]);
                pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
                pdf.save("download.pdf");
            });
        }
    }
}
</script> -->



<template>
  <div class="mainWrapper">
    <button @click="downloadPDF" class="pdfGenerateButton">
      <img :src="downloadPdf" class="pdfDownloadIcon" alt="download icon" />
    </button>

    <div ref="content" id="content" class="pdp-contentBoxes">
      <div class="page-heading m_lr-auto">
        <img :src="textHead" alt="heading image" />
      </div>

      <div class="pdf-contentBox">
        <div class="text-center">
          <img :src="totalTimeCalculation" class="max-w-80" alt="Total time calculation" />
          <br />
          <span class="text-center">
            <img :src="line" alt="bottom line" />
          </span>
        </div>

        <div class="text-center mt-15">
          <img :src="rulesHeading" class="max-w-80" alt="rules heading" />
        </div>

        <div class="white-text rulelistBox">
          <ul>
            <li v-for="(rule, index) in rules" :key="index">
              <div class="list-bulletIcon">
                <img :src="listBulletArrow" alt="" />
              </div>
              <div class="list-contet">
                {{ rule }}
                <div class="text-center">
                  <img :src="listBulletLine" alt="" />
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="text-center mt-15">
          <img :src="guidelinesHeading" class="max-w-80" alt="Guidelines heading" />
        </div>

        <div class="white-text rulelistBox">
          <ul>
            <!-- FIX: avoid shadowing the array name -->
            <li v-for="(guideline, index) in guidelinesForLiveStreaming" :key="index">
              <div class="list-bulletIcon">
                <img :src="listBulletArrow" alt="" />
              </div>
              <div class="list-contet">
                {{ guideline }}
                <div class="text-center">
                  <img :src="listBulletLine" alt="" />
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="pdf-bottomBox">
          <div class="pdf-bottom-leftBox">
            <div class="p-relative">
              <img :src="bottomAmountBg" alt="" />
              <div class="pdf-bottomReward-box">
                <div class="flexBox itemCenter justify-center white-text">
                  <div class="pdf-bottomRewardVal">150000</div>
                  <div class="p-relative pdf-bottom-beansIcon">
                    <img :src="beansWithStar" alt="Beans Icon" />
                  </div>
                </div>
              </div>
              <div class="rewardText-bottom">
                <img :src="rewardText" alt="" />
              </div>
            </div>
          </div>
          <div class="p-relative pdf-bottom-rightBox">
            <img :src="beansLootBox" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// NOTE: We use dynamic imports for html2canvas & jspdf in the method.
// Keep your CSS and asset imports as-is.
import '../../assets/css/freetarget.css'
import downloadPdf from '../../assets/images/feetargerImages/download-pdf.png'
import textHead from '../../assets/images/feetargerImages/textHead.png'
import totalTimeCalculation from '../../assets/images/feetargerImages/totalTimeCalculation.png'
import moreTimeHave from '../../assets/images/feetargerImages/moreTimeHave.png'
import rulesHeading from '../../assets/images/feetargerImages/rulesHeading.png'
import guidelinesHeading from '../../assets/images/feetargerImages/guidelinesHeading.png'
import listBulletLine from '../../assets/images/feetargerImages/listBulletLine.png'
import listBulletArrow from '../../assets/images/feetargerImages/listBulletArrow.png'
import line from '../../assets/images/feetargerImages/line.png'
import bottomAmountBg from '../../assets/images/feetargerImages/bottomAmountBg.png'
import beansWithStar from '../../assets/images/feetargerImages/beansWithStar.png'
import beansLootBox from '../../assets/images/feetargerImages/beansLootBox.png'
import rewardText from '../../assets/images/feetargerImages/as-a-reward.png'

export default {
  name: 'FreetargetUpdate',
  data() {
    return {
      downloadPdf,
      textHead,
      totalTimeCalculation,
      moreTimeHave,
      rulesHeading,
      guidelinesHeading,
      listBulletLine,
      listBulletArrow,
      line,
      bottomAmountBg,
      beansWithStar,
      beansLootBox,
      rewardText,
      rules: [
        'Timing extended for streaming 24/7.',
        'One should do live streaming and call for minimum of 4 hours a day (In total).',
        'For rewards, one should collect a minimum of 4 Stars in a week (*1 Star = Minimum 4 Hours Live Streaming/day).',
        'In this scheme one will get 150,000 coins as a reward on each Monday.',
        'Host/ Live Streamer has to make minimum of 50,000 beans/weeks for rewards.'
      ],
      guidelinesForLiveStreaming: [
        'Live Streamer background should be neat and clean. For better background one can use good background color.',
        'Live Streamer should use Bluetooth for voice clarity and Ring Light for Excellent Beatification Effects',
        'Live Streamer should wear smart casuals.'
      ]
    }
  },
  methods: {
    async downloadPDF() {
  const content = this.$refs.content;
  if (!content) return;

  // Loaded on demand so the PDF libraries are only fetched when the user
  // actually taps download, instead of on every page load.
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([
    import(/* webpackChunkName: "pdf-export" */ 'html2canvas'),
    import(/* webpackChunkName: "pdf-export" */ 'jspdf'),
  ]);

  const canvas = await html2canvas(content, {
    scale: 3,
    useCORS: true,
    backgroundColor: null,
    logging: false,
    windowWidth: document.body.scrollWidth,
  });

  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let position = 0;
  let heightLeft = imgHeight;

  pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    pdf.addPage();
    position = 0 - (imgHeight - heightLeft);
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  pdf.save('download.pdf');
}

  }
}
</script>
